'use strict';

import FormController from 'app/controllers/form';

class VehicleController extends FormController {
  /* @ngInject */
  constructor(
    VehiclesService,
    BrandsService,
    ClientsService,
    ProvincesService,
    FleetsService,
    $scope,
    $mdDialog,
    $mdToast,
    $state,
    $location
  ) {
    let vehicle = $scope.$parent.$resolve.vehicle;
    super(vehicle, 'Vehiculo', VehiclesService, null, 'vehicles');

    Object.assign(this, {
      VehiclesService,
      BrandsService,
      ClientsService,
      ProvincesService,
      FleetsService,
      $mdDialog,
      $mdToast,
      $state,
      $location
    });
    this.btnEnabled = true;

    if (this.model.id) {
      this.brand = this.model.brand;
      this.engineBrand = this.model.engineBrand;
      this.chassisBrand = this.model.chassisBrand;
    }
  }

  queryHolderSearch() {
    return this.ClientsService.findByText(this.searchHolderText);
  }

  selectedHolderChange(client) {
    this.model.holderId = client.id;
  }

  getClientName(client) {
    if (client) return client.lastName + ' ' + client.name;
  }

  searchFleet(text) {
    return this.FleetsService.find({
      where: {
        name: {
          ilike: `%${text}%`
        }
      }
    });
  }

  onFleetChange(fleet) {
    this.model.fleetId = fleet.id;
  }

  searchProvince(text) {
    return this.ProvincesService.find({
      where: {
        name: {
          ilike: `%${text}%`
        }
      }
    });
  }

  onProvinceChange(province) {
    this.model.provinceId = province.id;
  }

  $onInit() {
    super.$onInit();
    if (!this.model.fleet) {
      this.model.fleet = false;
    }
    if (this.model.province) {
      this.province = this.model.province;
    }
    if (this.model.holder) {
      this.holder = this.model.holder;
    }
    if (this.model.fleet) {
      this.fleet = this.model.fleet;
    }
  }

  save(ev) {
    super.save().catch(err => {
      this.showSpin = false;
      let error = err.data && err.data.error;
      if (error && error.code == 'VEHICLE_ALREADY_EXISTS') {
        var confirm = this.$mdDialog
          .confirm()
          .title('Vehiculo ya existe')
          .textContent(
            `Ya existe un vehiculo con mismo dominio o \
certificado, desea visualizarlo?`
          )
          .ariaLabel('Lucky day')
          .targetEvent(ev)
          .ok('Si, ir')
          .cancel('Cancelar y continuar en este');

        this.$mdDialog.show(confirm).then(() => {
          this.$state.go('editVehicle', {
            id: error.vehicleId
          });
        });
      } else if (error && error.code == 'VEHICLE_PLATE_OR_NUMBER_REQUIRED') {
        this.simpleError('DNI o CUIT es requerido');
      }
    });
  }

  queryBrandSearch(text) {
    return this.BrandsService.find({
      filter: {
        where: {
          name: {
            ilike: `%${text}%`
          }
        }
      }
    });
  }

  onSelectedBrand(brand) {
    if (!brand) return;

    this.brand = brand;
    this.model.brandId = brand.id;
  }

  onSelectedEngineBrand(brand) {
    if (!brand) return;

    this.engineBrand = brand;
    this.model.engineBrandId = brand.id;
  }

  onSelectedChassisBrand(brand) {
    if (!brand) return;

    this.chassisBrand = brand;
    this.model.chassisBrandId = brand.id;
  }
}

export default VehicleController;
